import _ from 'lodash';

/* @ngInject */
export default function GenericPanelService($q, $sails, $log, EquipmentInfoService) {
  const service = this;

  let genericModel = {};
  let equipmentStatus = {};

  service.getEquipmentFromIdsPerPanel = getEquipmentFromIdsPerPanel;
  service.getStatusForEquipment = getStatusForEquipment;
  service.setSetPoints = setSetPoints;
  service.destroy = destroy;

  /**
   * Get equipment objects based on panel and equipment ids.
   * Populate equipment into service model
   *
   * @param {string} panel ID
   * @param {Array<string>} equipmentIds
   * @returns {Promise<object>} Equipment
   */
  function getEquipmentFromIdsPerPanel(panel, equipmentIds) {
    return EquipmentInfoService
      .getFullEquipment(equipmentIds)
      .then((equipment) => {
        _.forEach(equipment, (eq) => {
          genericModel[panel] = genericModel[panel] || {};
          genericModel[panel][eq.id] = {
            equipment: eq
          };
        });
        return genericModel[panel];
      })
      .catch((error) => {
        $log.error('Error: ', error);
        return $q.reject(error.data);
      });
  }

  /**
   * Gets latest status for provided equipment
   *
   * @param {string} equipment ID
   * @param {boolean} refresh skip cache
   * @returns {Promise<object>} Status
   */
  function getStatusForEquipment(equipment, refresh = false) {
    if (equipmentStatus[equipment] && !refresh) {
      return $q.resolve(equipmentStatus[equipment]);
    }
    equipmentStatus[equipment] = $sails.get(`/equipment/${equipment}/statuses/getAllPoints/`)
      .then(({ data }) => {
        equipmentStatus[equipment] = data;
        return data;
      })
      .catch((error) => {
        equipmentStatus[equipment] = null;
        $log.error('Error: ', error);
        return $q.reject(error.data);
      });
    return equipmentStatus[equipment];
  }

  /**
   * Sends new data points to server
   *
   * @param {string} equipment ID
   * @param {object} points An object that contains values to update the status with
   * @returns {Promise} da promise
   */
  function setSetPoints(equipment, points) {
    return $sails.post(`/equipment/${equipment}/actions/setSetPoints`, points)
      .catch((error) => {
        $log.error('Error: ', error);
        return $q.reject(error.data);
      });
  }

  function destroy() {
    genericModel = {};
    equipmentStatus = {};
  }
}
